import {
  Box,
  Button,
  Text,
  Spinner,
  Badge,
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerHeader,
  DrawerOverlay,
  Divider,
  List,
  ListItem,
  ListIcon,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { AppDispatch } from "../../../../../redux/store";
import { RootState } from "../../../../../redux/reducer/rootReducer";
import { getProjects, getProjectsView } from "../../../../../redux/action";
import Title from "../../../../../components/Title";
import DataTableBase from "../../../../../components/data-table/data-table";
import { TableColumn } from "react-data-table-component";
import { ProjectData } from "../../../../../redux/reducer/projectReducer";
import { getAimStatement, getProject } from "../newproject/projectService";
import { color } from "../../../../../utils/theme";
import { MdCheckCircle } from "react-icons/md";
const ExsistingProject = () => {
  const dispatch: AppDispatch = useDispatch();
  const [project, setProject] = useState<ProjectData | any>();
  const [pending, setPending] = useState(true);
  const [rows, setRows] = useState<any[]>([]);
  const [projectsLoading, setProjectsLoading] = useState(false);
  const [openProjectDetail, setOpenProjectDetail] = useState(false);
  const projects: ProjectData[] | any[] = useSelector(
    (state: RootState) => state.projects.data
  );

  const fetchProjectDetils = async (projectId: number) => {
    if (projectId) {
      await getProject(Number(projectId))
        .then((res) => {
          setProject(res);
          setOpenProjectDetail(true);
        })
        .catch((err) => console.log(err));
    }
  };

  type DataRow = {
    id: number;
    name: string;
    project_start_date: string;
    department: string;
    aim_statement: string;
    technical_area: string;
    status: string;
    created_at: string;
    updated_at: string;
  };
  const columns: TableColumn<DataRow>[] = [
    {
      name: "#",
      selector: (row) => row.id,
      width: "50px",
    },
    {
      name: "Name",
      selector: (row) => row.name,
      sortable: true,
    },
    {
      name: "Project Start Date",
      selector: (row) => row.project_start_date,
      sortable: true,
    },
    {
      name: "Department",
      selector: (row) => row.department,
      sortable: true,
    },
    {
      name: "Technical Area",
      selector: (row) => row.technical_area,
      sortable: true,
    },
    {
      name: "Status",
      width: "100px",
      selector: (row) => row.status,
      cell: (row) => (
        <Badge colorScheme={row.status === "Open" ? "green" : "red"}>
          {row.status}
        </Badge>
      ),
      sortable: true,
    },
    {
      name: "",
      width: "100px",
      button: true,
      cell: (row) => (
        <Button
          colorScheme="green"
          w={"100%"}
          mx={2}
          h={"80%"}
          fontSize={13}
          onClick={() => {
            fetchProjectDetils(row.id);
          }}
        >
          View
        </Button>
      ),
      sortable: false,
    },
    {
      name: "",
      width: "100px",

      button: true,
      cell: () => (
        <Button colorScheme="blue" w={"100%"} mx={2} h={"80%"} fontSize={13}>
          Edit
        </Button>
      ),
      sortable: false,
    },
  ];

  const navigate = useNavigate();
  useEffect(() => {
    setPending(true);
    dispatch(getProjectsView());
  }, [dispatch]);

  useEffect(() => {
    if (projects.length > 0) {
      const updatedRows = projects.map((item, index) => ({
        id: item.id,
        name: item.name,
        project_start_date: item.project_start_date.toString().split("T")[0],
        department: item.department,
        aim_statement: item.aim_statement,
        technical_area: item.technical_area,
        status: item.status,
        created_at: item.created_at.toString().split("T")[0],
        updated_at: item.updated_at.toString().split("T")[0],
      }));
      setRows(updatedRows);
      setPending(false);
    }
  }, [projects]);

  const getAimStatementFromProject = (aim: any) => {
    if (aim) {
      return getAimStatement(aim.qit_name,aim.to, aim.project_aim, aim.from);
    }
    return "Not Available";
  }

  return (
    <>
      <Drawer
        size={"md"}
        isOpen={openProjectDetail}
        placement="right"
        onClose={() => setOpenProjectDetail(false)}
      >
        <DrawerOverlay />
        <DrawerContent>
          <DrawerCloseButton />
          <DrawerHeader w={"90%"} style={{ textAlign: "left", fontSize: 18 }}>
            {project?.name}
          </DrawerHeader>

          <DrawerBody
            h={"100%"}
            justifyContent={"space-between"}
            display={"flex"}
            flexDirection={"column"}
          >
            <Box>
              <Text fontWeight={"bold"}>Project Sponsor:</Text>
              <Text fontWeight={"normal"}>
                {project?.sponsor || "Not Available"}
              </Text>
              <Divider my={2} />
              <Text fontWeight={"bold"}>Problem Statement:</Text>
              <Text fontWeight={"normal"}>
                {project?.problem_statement?.complete_statement || "Not Available"}
              </Text>
              <Divider my={2} />
              <Text fontWeight={"bold"}>Aim Statement:</Text>
              <Text fontWeight={"normal"}>
                {getAimStatementFromProject(project?.aim_statement)}
              </Text>
              <Divider my={2} />
              <Text fontWeight={"bold"}>Project Aim:</Text>
              <Text fontWeight={"normal"}>
                {project?.aim_statement?.project_aim || "Not Available"}
              </Text>
              <Divider my={2} />
              <Text fontWeight={"bold"}>Department:</Text>
              <Text fontWeight={"normal"}>
                {project?.department?.name || "Not Available"}
              </Text>
              <Divider my={2} />
              <Text fontWeight={"bold"}>Project Start Data:</Text>
              <Text fontWeight={"normal"}>
                {project?.project_start_date.split("T")[0]}
              </Text>
              <Divider my={2} />
              <Text fontWeight={"bold"}>Project Last Revised:</Text>
              <Text fontWeight={"normal"}>
                {project?.last_revised.split("T")[0]}
              </Text>
              <Divider my={2} />
              <Text fontWeight={"bold"}>Change Ideas:</Text>
              {project?.change_ideas.length === 0 ? (
                <Text fontWeight={"normal"}>No Change Ideas</Text>
              ) : (
                <List gap="2">
                  {project?.change_ideas.map((idea: any, index: number) => (
                    <>
                      <ListItem>
                        <ListIcon as={MdCheckCircle} color="green.500" />
                        {idea?.name}
                      </ListItem>
                    </>
                  ))}
                </List>
              )}

              <Divider my={2} />
              <Text fontWeight={"bold"}>Measurements:</Text>
              {project?.measurements.length === 0 ? (
                <Text fontWeight={"normal"}>No Measurements.</Text>
              ) : (
                <List gap="2">
                  {project?.measurements.map(
                    (measurement: any, index: number) => (
                      <>
                        <ListItem>
                          <ListIcon as={MdCheckCircle} color="green.500" />
                          {measurement?.name.toString()}
                        </ListItem>
                      </>
                    )
                  )}
                </List>
              )}
            </Box>
            {/* Collapsible Cycles */}
            <Button
              colorScheme="blue"
              w={"100%"}
              mb={5}
              onClick={() => {
                console.log("project?.id", project?.id);
              }}
            >
              Go to project
            </Button>
          </DrawerBody>
        </DrawerContent>
      </Drawer>
      <Box
        display={"flex"}
        w={"80%"}
        mx={"auto"}
        alignSelf={"center"}
        flexDirection={"column"}
        justifyContent={"center"}
        alignContent={"center"}
        textAlign={"left"}
        mt={5}
      >
        <Title
          title={"Projects"}
          onClick={() => {
            navigate("/quality-improvement");
          }}
        />
        <DataTableBase
          title="Existing Projects"
          columns={columns}
          data={rows.sort((a, b) => a.id - b.id)}
          progressPending={pending}
          progressComponent={
            <Box
              mt={20}
              display={"flex"}
              flexDirection={"column"}
              justifyContent={"center"}
              alignContent={"center"}
              alignItems={"center"}
              gap={4}
            >
              <Spinner
                title="Getting existing challenges"
                color={color.primary}
              />
              <Text color={color.text} fontSize={16}>
                Fetching Projects
              </Text>
            </Box>
          }
          dense
          pagination
        />
      </Box>
    </>
  );
};

export default ExsistingProject;
